module.exports = __webpack_public_path__ + "percent_white_regular.6633e89747e5399254fb16f00338afba.svg";